import React from 'react';
import { Button } from '@mui/material';
import { Close, Email } from '@mui/icons-material';
import { Badge, Modal } from 'antd';

import { Credit } from '@types';
import { useModalState } from '@hooks';
import { useSettingsContext } from '@providers';
import { CreditChat } from '@components';
import cls from './credit-chat-btn.module.css';

interface Props {
  credit: Credit;
  boxClass?: string;
}

export const CreditChatBtn = ({ credit, boxClass }: Props) => {
  const { unreaded } = useSettingsContext();
  const { is: isChatOpened, show: showChat, hide: hideChat } = useModalState();
  const unreadedMessages = credit.chat && unreaded && unreaded.chats[credit.chat.id]?.unreaded;

  return (
    <div className={boxClass}>
      {credit.chat && unreadedMessages && unreadedMessages > 0 ? (
        <Badge count={unreadedMessages}>
          <Button color="secondary" variant="contained"
            className={cls.btn} onClick={showChat}>
            <Email className={cls.btnIcon} />
          </Button>
        </Badge>
      ) : (
        <Button
          color="secondary"
          variant="contained"
          className={cls.btn}
          onClick={showChat}
        >
          <Email className={cls.btnIcon} />
        </Button>
      )}

      <Modal
        title="Chat"
        open={isChatOpened}
        footer={false}
        onCancel={hideChat}
        closable
        closeIcon={<Close style={{ marginTop: 14 }} />}
      >
        {isChatOpened && (
          <CreditChat creditId={credit.id} height={338} closeChat={hideChat} />
        )}
      </Modal>
    </div>
  );
};
